
import { Navigate, useNavigate } from "react-router-dom"
export const RequireBeneficiaryTerms = ({children}) =>{
    const navigate = useNavigate()
    const terms = window.sessionStorage.getItem('ostreon_beneficiary_terms')
    console.log('Require Terms')
    console.log(terms)
    if (terms) return children
    else{ 
        console.log('ha entrado')
        return <Navigate to="/"/>
    }
  
    
}